type Listener = () => void

export type ChartBidAskState = {
    topBid: number
    topAsk: number
}

const bidAskByViewKey: Record<string, ChartBidAskState> = {}
const listenersByViewKey: Record<string, Set<Listener>> = {}

export function publishChartBidAsk(viewKey: string, topBid: number, topAsk: number) {
    const prev = bidAskByViewKey[viewKey]
    if (prev?.topBid === topBid && prev?.topAsk === topAsk) return
    bidAskByViewKey[viewKey] = { topBid, topAsk }
    listenersByViewKey[viewKey]?.forEach((listener) => listener())
}

export function getChartBidAsk(viewKey: string): ChartBidAskState {
    return bidAskByViewKey[viewKey] ?? { topBid: 0, topAsk: 0 }
}

export function subscribeChartBidAsk(viewKey: string, listener: Listener) {
    if (!listenersByViewKey[viewKey]) {
        listenersByViewKey[viewKey] = new Set()
    }
    listenersByViewKey[viewKey].add(listener)
    return () => {
        listenersByViewKey[viewKey]?.delete(listener)
    }
}
